import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StateService } from '../../services/state.service';

import { VerificationResponseDto } from '../../adapter/dto/verification-response.dto';

export const tokenGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const stateService: StateService = inject(StateService);
  const router: Router = inject(Router);
  const verifyResult: VerificationResponseDto | null = stateService.getVerificationResponse();
  const token: string | null = route.paramMap.get('token');
  const next: string = state.url;

  if (verifyResult === null) {
    return router.createUrlTree(['/vp', token], { queryParams: { next } });
  }
  return true;
};
